import { ImgID } from "../../image_loader/img_id.js";
import { NineSliceDictionary } from "../../image_loader/nine_slicer/nine_slice_dictionary.js";
import { UIElement } from "./ui_element.js";
import { UINineSliceElement } from "./ui_nine_slice_element.js";

// Source art of the play-dialog background half (bg_half_*.png) and the rows of
// play_dialog_bg_half in nine_slice_config.json: above SRC_TOP_CAP and below
// SRC_BOTTOM_CAP the rounded corners stay intact, only the gradient in between stretches.
const SRC_W = 482;
const SRC_TOP_CAP = 200;
const SRC_BOTTOM_CAP = 1189 - 960;
// The two halves overlap a little so no background shows through the seam.
const DESIGN_SEAM_OVERLAP = 4;

/** Dialog panel made of the left half of the art and its mirror, stretched only vertically. */
export function addMirroredDialogBg(
  ctx: CanvasRenderingContext2D,
  parent: UIElement,
  design_x: number,
  design_y: number,
  design_w: number,
  design_h: number,
  img_id: ImgID = ImgID.UI_PlayDialogBgHalfCommon
): void
{
  const design_half_w = design_w / 2 + DESIGN_SEAM_OVERLAP;
  const design_right_x = design_x + design_w - design_half_w;

  const half_w = LayoutScaler.widthFromDesign( design_half_w );
  const half_h = LayoutScaler.heightFromDesign( design_h );
  const left_x = LayoutScaler.xFromDesign( design_x );
  const right_x = LayoutScaler.xFromDesign( design_right_x );
  const bg_y = LayoutScaler.yFromDesign( design_y );
  const cap_scale = half_w / SRC_W;
  const caps = {
    top_left: { width: 0, height: SRC_TOP_CAP * cap_scale },
    bottom_right: { width: 0, height: SRC_BOTTOM_CAP * cap_scale },
  };

  const left_half = new UINineSliceElement(
    ctx, left_x, bg_y, half_w, half_h,
    img_id, NineSliceDictionary.values.play_dialog_bg_half, caps
  );
  parent.addChild( left_half );

  const right_half = new UINineSliceElement(
    ctx, right_x, bg_y, half_w, half_h,
    img_id, NineSliceDictionary.values.play_dialog_bg_half, caps
  );
  right_half.setFlipX( true );
  parent.addChild( right_half );
}
